import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;

        if (chunkFailedMessage.test(error?.message)) {
            window.location.reload();
            return;
        }

        const unwrapped = error?.originalError || error;

        // Failed requests already reach Sentry through
        // HttpErrorReporterService, with url, status and request id attached.
        // Capturing them again here would only add a duplicate issue — and a
        // poor one, since HttpErrorResponse is not an Error and would be
        // recorded as "Non-Error exception captured" without a stack trace.
        if (!(unwrapped instanceof HttpErrorResponse)) {
            Sentry.captureException(unwrapped);
        }
        console.error(error);
    }
}
